/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Divider, Input, ModalBody, ModalFooter, ModalHeader, Select, SelectItem, Spinner } from '@nextui-org/react';
import toast from 'react-hot-toast';
// import { UsersService } from '../../../services';
import { IconTrash } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { SchoolService } from '../../../../services';
import { formatNumericFields, Constants } from '../../../../utils';

const TYPE_QUALIFICATION_OPTIONS = [
  { key: String(Constants.SUBJECTS.TYPE_QUALIFICATION.QUANTITATIVE), label: 'Cuantitativa' },
  { key: String(Constants.SUBJECTS.TYPE_QUALIFICATION.QUALITATIVE), label: 'Cualitativa' },
];

const ModalCreateGrade = ({ item, onSuccess, onClose }) => {
  const { addSubject, form, onChange, onSubmit, removeSubject, schoolYears, data, loading, filteredGrades } = useForm(item);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }


  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!item ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8 relative">
        {loading ?? (
          <div className="absolute w-full h-full inset-0 z-[70] flex justify-center items-center bg-white/30">
            <Spinner />
          </div>
        )}
        <div className="flex flex-col flex-1 gap-4">
          <Select
            label="Año escolar"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            isDisabled={!!item}
            disallowEmptySelection={true}
            selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
            onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
          >
            {schoolYears.map((item) => (
              <SelectItem key={item.id} value={item.id}>
                {item.name}
              </SelectItem>
            ))}
          </Select>

          <Select
            label="Grado"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}

            disallowEmptySelection={true}
            isDisabled={form.school_year_id.length === 0 || !!item}
            selectedKeys={!!form.school_grade_id ? [form.school_grade_id] : []}
            onSelectionChange={v => onChange(v.currentKey, 'school_grade_id')}
          >
            {filteredGrades.map((item) => (
              <SelectItem key={item.id} value={item.id}>
                {item.name}
              </SelectItem>
            ))}
          </Select>

          <Divider />

          <Input
            label="Nombre de la materia"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form._subjectName}
            onValueChange={v => onChange(v, '_subjectName')}
          />
          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Código de la materia"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form._subjectCode}
              onValueChange={v => onChange(v, '_subjectCode')}
            />
            <Input
              label="Horas semanales"
              labelPlacement="outside"
              placeholder=" "
              type="number"
              radius="sm"
              step="1"
              variant="bordered"
              value={form._subjectHours}
              onValueChange={v => onChange(v, '_subjectHours')}
            />
          </div>

          <Select
            label="Tipo de calificación"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={form._subjectType_qualification ? [String(form._subjectType_qualification)] : []}
            onSelectionChange={(v) => onChange(v.currentKey, '_subjectType_qualification')}
          >
            {TYPE_QUALIFICATION_OPTIONS.map((opt) => (
              <SelectItem key={opt.key} value={opt.key}>
                {opt.label}
              </SelectItem>
            ))}
          </Select>

          <Button
            variant="flat"
            onClick={addSubject}
            isDisabled={!form._subjectName || !form._subjectCode || !form._subjectHours || !form._subjectType_qualification}
          >
            Agregar
          </Button>



          <Divider />

          {!!data.length && (
            <div className="text-sm font-medium">
              <div className="grid grid-cols-5 gap-4 bg-default-100 p-2 rounded-lg">
                <span className="col-span-1">Nombre</span>  {/* Ajustamos el tamaño de las columnas */}
                <span className="text-center">Código</span>
                <span className="text-center">Horas</span>
                <span className="text-center">Calificación</span>
              </div>
              {data.map((subject, subjectIdx) => (
                <div className="grid grid-cols-5 gap-4 p-2 border-b border-default-200">
                  <span className="col-span-1">{subject.subject_name}</span>
                  <span className="text-center">{subject.code}</span>
                  <span className="text-center">{subject.hours}</span>
                  <span className="text-center">
                    {
                      subject.type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUALITATIVE ? 'Cualitativa'
                      : subject.type_qualification == Constants.SUBJECTS.TYPE_QUALIFICATION.QUANTITATIVE ? 'Cuantitativa' : ''
                    }
                  </span>
                  <div className="flex justify-end items-center">
                    <IconTrash 
                      className="cursor-pointer"
                      onClick={() => removeSubject(subjectIdx)} 
                    />
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item) => {
  const initialForm = {
    school_year_id: '',
    school_grade_id: '',
    _subjectName: '',
    _subjectCode: '',
    _subjectHours: '',
    _subjectType_qualification: '',
  };
  const user = useSelector((state) => state.user)
  const [form, setForm] = useState(initialForm);
  const [subjects, setSubjects] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [loading, setLoading] = useState(false);
  const [filteredGrades, setFilteredGrades] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const grades = useRef([])



  const onChange = (value, target) => {
    if (target === 'school_year_id') {
      setForm(s => ({ ...s, school_grade_id: '' }))
    }

    setForm(s => ({ ...s, [target]: value }));
  }

  const addSubject = () => {

    if (!form._subjectName || !form._subjectCode || !form._subjectHours || !form._subjectType_qualification) return;

    const findSubjectName = subjects.find(x => x.subject_name?.trim()?.toLowerCase() === form._subjectName?.trim()?.toLowerCase());
    const findSubjectCode = subjects.find(x => x.code?.trim()?.toLowerCase() === form._subjectCode?.trim()?.toLowerCase());

    if (findSubjectName) {
      return onError(`El nombre de la materia ${form._subjectName} ya la registró`);
    }

    if (findSubjectCode) {
      return onError(`El código de la materia ${form._subjectCode} ya la registró`);
    }

    setSubjects([
      ...subjects,
      {
        subject_name: form._subjectName,
        code: form._subjectCode,
        hours: +form._subjectHours,
        type_qualification: form._subjectType_qualification,
      }
    ]);

    setForm(s => ({
      ...s,
      _subjectName: '',
      _subjectCode: '',
      _subjectHours: '',
      _subjectType_qualification: '',
    }));
  }

  const removeSubject = (index) => {
    setSubjects(subjects.filter((_, idx) => index !== idx));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }


  const getSchoolYears = async () => {
    if (!canFetch) return;
    setCanFetch(false);
    setLoading(true);
    try {
      const gradesData = await SchoolService.schoolAdmin.getGrades({ school_id: user.id });
      const schoolYears = await SchoolService.schoolAdmin.getSchoolarsYears();
      setSchoolYears(schoolYears);
      grades.current = gradesData;
      setFilteredGrades(gradesData);
      setCanFetch(true);

    } catch (error) {
      setSchoolYears([]);
      onError(String(error));
    } finally {
      setLoading(false);
    }
  }

  const isValidForm = () => {
    if (!form.school_grade_id)
      return onError('Debe seleccionar el grado');

    if (!item && !subjects.length)
      return onError('Debe indicar al menos una materia');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      const numericFields = ['school_grade_id']
      const formattedData = formatNumericFields(form, numericFields);
      const data = { ...formattedData, school_id: user.id, subjects }
      await SchoolService.schoolAdmin.createSubject(data)
      toast.success(`Materias agregadas correctamente`);
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  useEffect(() => {
    getSchoolYears();
  }, [])

  useEffect(() => {
    setFilteredGrades(grades.current.filter(x => {
      const bySchoolYear = x.school_year_id === +form.school_year_id;
      //const found = subject.some((y) => y.id === x.id)
      return bySchoolYear
    }));
  }, [form.school_year_id])

  useEffect(() => {

    if (!!item) {
      setForm({
        school_year_id: String(item.school_year_id),
        school_grade_id: String(item.id),
      });
    }
  }, [schoolYears])



  return {
    addSubject,
    form,
    onChange,
    onSubmit,
    removeSubject,
    loading,
    data: subjects,
    schoolYears,
    filteredGrades,
  }
}

export default ModalCreateGrade;
